import IPagination from '../../../common/interfaces/IPagination';
import IUserRequestsDataTable from '../interfaces/IUserRequestsDataTable';
import IUsersDataTable from '../interfaces/IUsersDataTable';

export const PATH = '/users';
export const PATH_USER_REQUEST = '/users-request';

export const PAGE_TITLE = 'GestaoUsuarios';
export const PAGE_SIZE = 12;

export const DEFAULT_DATA = {
    currentPage: 0,
    data: [] as IUsersDataTable[],
    totalItems: 0,
    totalPages: 0,
} as IPagination<IUsersDataTable>;

export const DEFAULT_DATA_USER_REQUEST = {
    currentPage: 0,
    data: [] as IUserRequestsDataTable[],
    totalItems: 0,
    totalPages: 0,
} as IPagination<IUserRequestsDataTable>;
